const ADD_HOLIDAY = (context, payload) => {
  context.holidayList.push({
    name: payload.dayName,
    value: payload.newDay,
  });
};

const REMOVE_HOLIDAY = (context, dayKey) => {
  context.holidayList.splice(dayKey, 1);
};

const ADD_EXCEPTION = (context, newDay) => {
  context.exceptionList.push({ name: newDay });
};

const REMOVE_EXCEPTION = (context, dayKey) => {
  context.exceptionList.splice(dayKey, 1);
};

export default {
  ADD_HOLIDAY,
  REMOVE_HOLIDAY,
  ADD_EXCEPTION,
  REMOVE_EXCEPTION,
};
